/* eslint-disable react/jsx-props-no-spreading */
import React, { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
// import { Link } from "react-router-dom";
import Slider from "react-slick";
import ModalAlertBold from "./ModalAlertBold";

function LogoSlide({ setPopBox, setExpireCookie, imgData }: any) {
  const location = useLocation();
  // console.log("isMobile", isMobile);
  // console.log("imgData", imgData);

  const settings = {
    dots: true,
    autoplay: true,
    speed: 400,
    autoplaySpeed: 2000,
    arrows: false,
    swipeToSlide: true,
    cssEase: "ease-out",
    // beforeChange: (current: any, next: any) => {
    //   setCurrentIndex(next);
    // },
  };

  const preventScroll = (e: Event) => {
    e.preventDefault();
  };

  useEffect(() => {
    const { body } = document;
    if (setPopBox) {
      body.addEventListener("wheel", preventScroll, { passive: false });
      body.style.overflowY = "hidden";
    }
    return () => {
      body.removeEventListener("wheel", preventScroll);
      body.style.overflowY = "";
    };
  }, [setPopBox]);

  const eventLink = (link: any) => {
    // console.log("link", link);
    const script = document.createElement("script");
    script.setAttribute("class", "popup_home_link");
    script.type = "text/javascript";
    script.text = `if (typeof app_ExternalLink === "function") {
      app_ExternalLink('${link}')
      } else { window.open('${link}', '_blank') }`;
    document.head.appendChild(script);
    setPopBox(false);
  };

  return (
    <div
      className="popup-slide-banner"
      style={{
        width: "329px",
        maxWidth: "548px",
        touchAction: "none",
      }}
    >
      <ModalAlertBold
        subTitle={
          <Slider {...settings}>
            {imgData?.map((img: any) => (
              <div key={img.banner_no}>
                {img.banner_link.includes("http") ? (
                  <Link
                    to={location.pathname}
                    // href="/"
                    // target="_self"
                    // rel="noreferrer"
                    onClick={() => eventLink(img?.banner_link)}
                  >
                    <img src={img.banner_sm} alt="popup" width="100%" />
                  </Link>
                ) : (
                  <Link to={img.banner_link}>
                    <img src={img.banner_sm} alt="popup" width="100%" />
                  </Link>
                )}
              </div>
            ))}
          </Slider>
        }
        leftBtnName="다시 보지 않기"
        leftBtnFunc={() => setExpireCookie(false)}
        rightBtnName="닫기"
        rightBtnColor="#E8EBED"
        rightBtnFunc={() => setPopBox(false)}
        backgroundColor="transparent"
      />
    </div>
  );
}

export default LogoSlide;
